import { render, staticRenderFns } from "./ProjectThumbnails.vue?vue&type=template&id=b098e754&scoped=true"
import script from "./ProjectThumbnails.vue?vue&type=script&lang=ts"
export * from "./ProjectThumbnails.vue?vue&type=script&lang=ts"
import style0 from "./ProjectThumbnails.vue?vue&type=style&index=0&id=b098e754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b098e754",
  null
  
)

export default component.exports